import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sort-icon',
  templateUrl: './sort-icon.component.html',
  styleUrl: './sort-icon.component.scss', 
  standalone: false
})
export class SortIconComponent {
  @Input() public size: number = 14;
  @Input() public sortDirection: 1 | -1 | null = null;
}
